<template>
    <div class="item-wrap"  @click.stop="showMore">
        <!-- 口碑榜单 -->
        <img v-if="itemInfo.display_order==10" class="mouth-list" src="@/assets/images/household/word-month.png" alt="">
        <!-- 用户信息 -->
        <div class="user" >
            <div class="head-img"><img :src="itemInfo.comment_info.headimgurl || itemInfo.avatar" alt=""></div>
            <div class="user-info">
                <div class="name">{{ itemInfo.comment_info.nickname || itemInfo.uname }}</div>
                <div class="tag">
                    <div class="left-tag">{{ itemInfo.created_at }}</div>
                    <div class="right-more"><span>查看全文</span><img src="@/assets/images/household/right.png" alt=""></div>
                </div>
            </div>
        </div>
        <!-- 标题 -->
        <div class="title-case">{{ itemInfo.city_name }}-{{ itemInfo.address }} {{ itemInfo.house_area }}m²户型 安装案例</div>
        <!-- 产品标签 -->
        <div class="tag-wrap">
            <span v-for="i in itemInfo.arrCategory" :key="i.id"> · {{ i.type_name }}</span>
        </div>
        <!-- 评价 (接口暂无此字段)-->
        <div class="evaluate" v-if="itemInfo.comment_info.sub_content">{{ itemInfo.comment_info.sub_content }}</div>
        <!-- 图片展示 -->
        <div class="content_pic" v-if="itemInfo.imgArr && itemInfo.imgArr.length">
            <div v-if="itemInfo.videoArr && itemInfo.videoArr.length">
                <div class="content_pic_box" v-show="videoindex < 1" v-for="(videoitem, videoindex) in itemInfo.videoArr" @click.stop="viewVideoSrc = videoitem.mp4_url" :key="videoitem.id">
                    <video :src="videoitem.mp4_url" :poster="videoitem.mp4_square_cover_url" width="100%" height="auto"></video>
                    <img src="../../assets/images/icon_play.png" class="icon-play"/>
                </div>
            </div>
            <div v-for="(uloaditem, uloadindex) in itemInfo.imgArr" :key="uloaditem.img_id" :class="(uloadindex % 3) - 2 ? '' : 'cladiv'" v-show="uloadindex < 9">
                <img v-lazy="uloaditem.img_url" v-if="uloaditem.img_id"/>
            </div>
        </div>
        <div class="content_pic" v-else-if="itemInfo.imgs">
            <img v-for="(imgitem, imgindex) in itemInfo.imgs" :key="imgitem.id" v-lazy="imgitem.url"/>
        </div>
        <div class="content_pic" v-else>
            <img src="https://pro-core.babycdn.com/2020/08aosmith/images2020/watersystem/old/default_one_img.png" alt/>
        </div>
        <!-- 评价得分 -->
        <div class="score">
            <div class="title" v-if=" itemInfo.comment_info.main_score">整体评价</div>
            <div class="start-wrap">
                <div class="left-start" v-if=" itemInfo.comment_info.main_score">
                    <!-- <img class="start-img" v-for="(startItem,index) in itemInfo.comment_info.main_score" :key="index+1*99" src="@/assets/images/household/start.png" alt="">
                    <img class="start-img" v-for="(startItem,index) in 5-itemInfo.comment_info.main_score" :key="index+2*98" src="@/assets/images/household/kong-start.png" alt=""> -->
                     <div class="start_icon" v-for="(iconItem,iconIndex) in 5" :key="iconIndex">
                    <img class="start-quan-img" v-if="iconIndex <= toFix(itemInfo.comment_info.main_score) - 1" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/case/details/start.png"/>
                    <img class="start-left-img" v-if="count(itemInfo.comment_info.main_score)&&iconIndex ==  toFix(itemInfo.comment_info.main_score)" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/case/details/left_start.jpg"/>
                     </div>
                    <span class="score-text">{{ itemInfo.comment_info.main_score }}分</span>
                </div>
                <div v-else class="left-start"></div>
                <div class="info-data">
                    <div class="item"><img src="@/assets/images/household/views.png" alt=""><span>{{ itemInfo.views }}</span></div>
                    <div class="item"><img v-if="!itemInfo.is_collect" src="@/assets/images/household/start2.png" alt=""><img v-else src="@/assets/images/household/start.png" alt=""><span>{{ itemInfo.collect_num }}</span></div>
                    <div class="item"><img src="@/assets/images/household/share.png" alt=""><span>{{ itemInfo.share_num }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default ({
    props: {
        itemInfo: {
            typeof: Object,
        },
        index: {
            typeof: Number
        },
    },
    data() {
        return {}
    },
    methods: {
        //   点击查看更多
        showMore() {
            this.$emit('showMore', {id: this.itemInfo.id, isnew: this.itemInfo.is_new, item: this.itemInfo})
        },
        // 点击收藏(目前关闭状态)
        collectClick() {
            this.$emit('collectClick', {item: this.itemInfo})
        },
        // 点击分享(关闭状态)
        showSharePopup() {
            this.$emit('showSharePopup', {item: this.itemInfo})
        },
        toFix (value) {
        if(value >= 4.9){
            value = 5
        }
        return parseInt(value)
        },
        count (value) {
           let num = parseInt(value);
            if(value - num > 0.1){
                return 1
            }else{
                return 0
            }
        }
    },
    created() {
        // console.log(this.itemInfo, '数据')
    },
})
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>